import {createSvgIcon} from '../create-svg-icon';

export const SwapVertIcon = createSvgIcon(
  <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3 5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3 5 6.99h3V14h2V6.99h3L9 3z" />
, 'SwapVertOutlined');
